import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";

@Component({
	templateUrl: "./terms-conditions.component.html",
	styleUrls: ["./terms-conditions.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TermsAndConditionsComponent {
	@Output() modalResult = new EventEmitter<boolean>();
	accepting = false;

	onAccept() {
		this.accepting = true;
		this.modalResult.emit(true);
	}

	onDecline() {
		this.modalResult.emit(false);
	}
}
